<div class="text-start-dir">
  @if (label) {
  <label class="date-picker-label">{{ label }}</label>
  }
  <mat-form-field
    [appearance]="appearance"
    [style.width]="width"
    [class]="cssClass">
    <mat-date-range-input [formGroup]="formGroup" [rangePicker]="picker">
      <input
        matStartDate
        [formControlName]="fromControlName"
        [placeholder]="fromPlaceholder"
        (click)="picker.open()"
        (dateChange)="onDateChange()" />
      <input
        matEndDate
        [formControlName]="toControlName"
        [placeholder]="toPlaceholder"
        (click)="picker.open()"
        (dateChange)="onDateChange()" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker">
      <img
        matDatepickerToggleIcon
        [src]="calendarIcon"
        alt="Calendar"
        width="14"
        height="16" />
    </mat-datepicker-toggle>
    <mat-date-range-picker #picker> </mat-date-range-picker>
  </mat-form-field>
</div>
